module.exports = __webpack_public_path__ + "img/gpt-android-step-0.78335de6.png";